var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "yj-sso" }, [
    _c("p", { domProps: { innerHTML: _vm._s(_vm.tip) } }),
    _vm.tryLogin
      ? _c("p", { staticClass: "yj-sso-logout", on: { click: _vm.logout } }, [
          _vm._v("重新登录"),
        ])
      : _vm.isSelf === false
      ? _c("p", { staticClass: "yj-sso-back", on: { click: _vm.back } }, [
          _vm._v("返回上一页"),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }